declare var $: any;
//System
import { Component, HostListener, ElementRef, Renderer2, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewEncapsulation, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { catchError, Subject, take, takeUntil, tap, Subscription, forkJoin, of } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {Title} from "@angular/platform-browser";
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

//Third Party
import * as moment from 'moment';

//Components
import { AuthBaseComponent } from 'src/app/components/auth-base/auth-base.component';

//Services
import { LogService } from 'src/app/services/common/log.service';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { FacilityService } from 'src/app/services/facility.service';
import { ClassesService } from 'src/app/services/classes.service';
import { FeatureSupportService } from 'src/app/services/feature-support.service';
import { UserService } from 'src/app/services/user.service';
import { InviteCodeService } from 'src/app/services/invite-code.service';
import { MetaService } from 'src/app/services/meta.service';
import { SessionWaitlistService } from 'src/app/services/session-waitlist.service';

//Models
import { MemberModel } from 'src/app/models/member';
import { InviteCode, InviteCodeRedeemRequest } from 'src/app/models/invite-code';
import { InstructorDetails, ClassesTab, ClassDetails } from 'src/app/models/meta';
import { Studio, Session} from 'src/app/models/studio/session-details';
import {
  CLASS_FILTER_DEFAULT_END_TIME,
  CLASS_FILTER_DEFAULT_START_TIME,
  createDefaultFilterModel,
  FilterModel,
} from 'src/app/models/studio/classes';
import {
  PARTNER_BOOKING_UNAVAILABLE_MESSAGE,
  PartnerLocationOption,
  addressesForSelectedSchedule,
  apiStudioIds,
  canSeeSharedSchedule,
  excludePartnerArtifacts,
  formatScheduleSelection,
  instructorTokensForScheduleUrl,
  instructorsForScheduleSelection,
  instructorsFromPartnerSessions,
  isPartnerArtifact,
  parseScheduleSelection,
  partnerLocationsForViewer,
  partnerScheduleKey,
  readPartnerQueryParam,
  resolveInstructorIdsFromTokens,
  selectionIncludesHost,
  sessionVenueName,
  sessionsForScheduleView,
  studiosForScheduleSelection,
  syntheticStudioForPartner,
  toggleHostInSelection,
  togglePartnerInSelection,
} from 'src/app/models/studio/shared-schedule';

//Utils
import { Utils } from 'src/app/services/common/utils';
import { SessionFilterComponent } from 'src/app/components/popups/session-filter/session-filter.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { Address, Location } from 'src/app/models/common-models';
import { PromoBannerStrip } from 'src/environments/environment.interface';
import { Action, EmployeeState, Status } from 'src/app/models/enums';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { SessionWaitlist } from 'src/app/models/studio/session-details';

@Component({
  selector: 'class-schedule',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './class-schedule.component.html',
  styleUrls: ['./class-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ClassScheduleComponent extends AuthBaseComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('slickCarousel', { static: false }) slickCarousel!: SlickCarouselComponent;
  @ViewChild('sessionsWrapper', { static: false }) sessionsWrapperDiv!: ElementRef;

  bannerObj: PromoBannerStrip | null;
  memberId: number = 0;

  date: string = '';
  currentMember!: MemberModel;

  studioIds: number[] = [];
  instructorIds: number[] = [];

  //Pagination
  slides : any = [];
  sessions : Session[] = [];
  firstVisibleSession! : Session;
  
  inviteCode!: InviteCode;
  inviteCodeStr: string = "";
  locationId: number = 1;

  slideStartDate = "";
  slideEndDate = "";
  rangeStart = "";
  rangeEnd = "";
  currentDate = new Date();
  currentDateYYYYMMDD = "";
  currentDateStr = "";
  disableScrollEvent = false;
  sessionLimit = 40;
  showLoadMore = true;
  private scrollThrottleTimer: any = null;
  private isScrolling = false;
  private scrollTimeout: any = null;
  private lastSlideIndex = -1;
  private dateFormatCache = new Map<string, { month: string, date: string, day: string }>();
  private sessionTimeCache = new Map<string, string>();
  classesTab!: ClassesTab;
  studios!: Studio[] | undefined;
  instructors!: InstructorDetails[] | undefined;
  private hostStudios: Studio[] = [];
  private hostInstructors: InstructorDetails[] = [];
  private allSessions: Session[] = [];
  partnerLocations: PartnerLocationOption[] = [];
  studioByPartner: { [key: string]: Studio } = {};
  instructorsByPartner: { [key: string]: InstructorDetails[] } = {};
  sharedScheduleAllowed = false;
  private pendingStudioSlugs: string[] = [];
  private pendingInstructorSlugs: string[] = [];
  addresses: Address[];
  locations: Location[] = [];
  filterCount: number = 0;
  bodyHeight: number = 500;

  isIframeRoute: boolean = false;

  private readonly scheduleStorageCategory = 'classSchedule';

  slideConfig = {"infinite": false, "slidesToShow": 7, "slidesToScroll": 7, "arrows": false};
  filterConfig : any;
  quickFilter : string = 'studio';
  canGoPrev = false;
  canGoNext = false;

  //Sessions
  private readonly _unsubscribe: Subject<any> = new Subject();

  filteredSessions!: Session[] | null;
  bookings!: any[] | null;
  private bookingsSet = new Set<number>();
  private waitlistSessionSet = new Set<number>();
  private pendingWaitlistSessionSet = new Set<number>();
  template: string = '';
  filterModel: FilterModel = createDefaultFilterModel();


  private studioSubscription!: Subscription;

  constructor(private titleService:Title
    , private logService: LogService
    , private activeRoute: ActivatedRoute
    , private router: Router
    , private alertService: AlertService
    , private modalService: NgbModal
    , private _classesService: ClassesService
    , private _user: UserService
    , private authService: AuthService
    , private inviteCodeService: InviteCodeService
    , private _featureSupport: FeatureSupportService
    , private metaService: MetaService
    , private renderer: Renderer2
    , private el: ElementRef
    , private _environmentService: EnvironmentService
    , private facilityService: FacilityService
    , private cdr: ChangeDetectorRef
    , private localStorageService: LocalStorageService
    , private sessionWaitlistService: SessionWaitlistService
  ) {
    super(router, logService, alertService, facilityService);
    this.filterConfig = this._environmentService.getFacilityConfig().schedule.filters;
    this.template = this._environmentService.getFacilityConfig().schedule.template;
    this.quickFilter = this._environmentService.getFacilityConfig().schedule.quickFilter;
  }

  /** Active filter/selected location timezone, then facility default — never the visitor's system timezone. */
  private getScheduleTimeZone(): string {
    const candidates = [
      this.locations?.find((loc) => loc.Id === this.filterModel.LocationId)?.TimeZone,
      this.localStorageService.getProperty<Location>('location', 'selectedLocation')?.TimeZone,
      this._environmentService.getFacilityConfig()?.timezone,
      'America/New_York',
    ];
    for (const tz of candidates) {
      if (tz && this.isValidTimeZone(tz)) {
        return tz;
      }
    }
    return 'America/New_York';
  }

  /** Prefer each session's LocationId timezone; facility default only as fallback. */
  private getSessionTimeZone(session: { LocationId?: number }): string {
    return Utils.resolveSessionTimeZoneFromLocations(
      session?.LocationId,
      this.locations,
      this._environmentService.getFacilityConfig()?.timezone
    );
  }

  private isValidTimeZone(timeZone: string): boolean {
    try {
      Intl.DateTimeFormat('en-US', { timeZone }).format(new Date());
      return true;
    } catch {
      return false;
    }
  }

  private getTodayInScheduleTimeZone(): string {
    return Utils.getTodayDateStringInTimezone(this.getScheduleTimeZone());
  }

  private getSessionDateString(session: { StartDate: Date | string }): string {
    return Utils.getSessionCalendarDateString(session.StartDate);
  }

  override async ngOnInit() {
    this.filteredSessions = null;
    await super.ngOnInit();

    const currentRoute = this.router.url;
    this.isIframeRoute = currentRoute.includes('-iframe');

    this.locationId = this.activeRoute.snapshot.queryParams['location_id'];
    this.inviteCodeStr = this.activeRoute.snapshot.queryParams['invite_code'];

    // Get member ID FIRST before trying to load bookings
    this.currentMember = this.authService.getLoggedInMember();
    this.memberId = this.currentMember?.Id || 0;
    this.sharedScheduleAllowed = canSeeSharedSchedule(
      this._environmentService.getFacilityConfig().featureFlags,
      this.memberId
    );
    
    // Load bookings early if member is already logged in
    if (this.memberId > 0) {
      this.loadBookings();
    }

    // Refresh bookings when returning from booking a session
    this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      takeUntil(this._unsubscribe)
    ).subscribe((event: NavigationEnd) => {
      // Only refresh if we're on the class schedule page
      if (event.url.includes('/class-schedule') && this.memberId > 0) {
        // Small delay to ensure the booking is saved
        setTimeout(() => {
          this.loadBookings(true);
        }, 500);
      }
    });

    if(this.memberId == 0)
    {
      this.bannerObj = this._environmentService.getPromoBanner('classSchedulePage');
    }

    if(this.inviteCodeStr && this.currentMember)
    {
      const redeemRequest : InviteCodeRedeemRequest = {
        MemberId : this.currentMember.Id,
        Code: this.inviteCodeStr
      };

      this.inviteCodeService.redeemInviteCode(redeemRequest).subscribe((data: InviteCode | string) => {
        if(typeof(data) === 'string')
        {
          this.alertService.error(data);
          return;
        } else {
          this.inviteCode = data;
          this.alertService.info("Code has been redeemed successfully.");
        }
      });
    }

    var studioNameSlug : string = this.activeRoute.snapshot.queryParams['studio'] || '';
    var studioNameSlugArray : string[] = studioNameSlug.split(',');
    var instructorNameSlug : string = this.activeRoute.snapshot.queryParams['instructor'] || '';
    var instructorNameSlugArray : string[] = instructorNameSlug.split(',');
    var timeRangeStr : string = this.activeRoute.snapshot.queryParams['time_range'] || '';
    var timeRangeArray : string[] = timeRangeStr.split(',');
    var addressIdsStr : string = this.activeRoute.snapshot.queryParams['address'] || '';
    var addressArray: number[] = addressIdsStr.split(',').filter(str => str.trim() !== '').map(Number).filter(num => !isNaN(num));
    var locationIdStr : string = this.activeRoute.snapshot.queryParams['location'] || '';
    var locationIdParam: number = locationIdStr ? Number(locationIdStr) : 0;
    const partnerKeyParam: string = this.sharedScheduleAllowed
      ? readPartnerQueryParam(this.activeRoute.snapshot.queryParams['partner'])
      : '';
    this.filterModel.PartnerKey = formatScheduleSelection(parseScheduleSelection(partnerKeyParam));
    this.pendingStudioSlugs = studioNameSlugArray.filter(slug => slug.trim() !== '');
    this.pendingInstructorSlugs = instructorNameSlugArray.filter(slug => slug.trim() !== '');
    const deferEntityFilters = parseScheduleSelection(this.filterModel.PartnerKey).partnerKeys.length > 0;

    // Determine LocationId early so it's available when filtering studios/instructors
    if (locationIdParam > 0) {
      this.filterModel.LocationId = locationIdParam;
    } else if (this.currentMember && this.currentMember.LocationId && this.currentMember.LocationId > 0) {
      // If no location in URL, use member's default LocationId if logged in
      this.filterModel.LocationId = this.currentMember.LocationId;
    } else {
      // Try to get from localStorage as fallback
      const storedLocation = this.localStorageService.getLocation();
      if (storedLocation && storedLocation.Id && storedLocation.Id > 0) {
        this.filterModel.LocationId = storedLocation.Id;
      }
    }

    if(timeRangeArray.length >= 2)
    {
      var startTime : number = parseInt(timeRangeArray[0]);
      if(Number.isNaN(startTime)){
        this.filterModel.StartTime = CLASS_FILTER_DEFAULT_START_TIME;
      } else {
        this.filterModel.StartTime = startTime;
      }

      var endTime : number = parseInt(timeRangeArray[1]);
      if(Number.isNaN(endTime)){
        this.filterModel.EndTime = CLASS_FILTER_DEFAULT_END_TIME;
      } else {
        this.filterModel.EndTime = endTime;
      }
    }

    // Load meta first to get filter IDs, then load sessions
    this.studioSubscription = this.metaService.getClassesMeta(false, this.filterModel.LocationId).pipe(
      takeUntil(this._unsubscribe)
    ).subscribe((data: ClassesTab) => {
      this.classesTab = data;
      // Process meta data
      this.hostStudios = excludePartnerArtifacts(this.classesTab.Studios).filter(studio => studio.State == Status.Active && studio.LocationId == this.filterModel.LocationId);
      this.hostInstructors = excludePartnerArtifacts(this.classesTab.Instructors).filter(instructor => instructor.State == EmployeeState.Active && instructor.LocationId == this.filterModel.LocationId);
      this.studios = this.hostStudios;
      this.instructors = this.hostInstructors;
      this.addresses = [];
      const uniqueAddresses = new Map<number, Address>();
      this.classesTab.Classes.forEach((element: ClassDetails) => {
        if (element.Address && !uniqueAddresses.has(element.Address.Id)) {
          uniqueAddresses.set(element.Address.Id, element.Address);
        }
      });
      this.addresses = Array.from(uniqueAddresses.values());
      this.filterModel.AddressIds = [];

      // Optimize filter processing with Map lookups
      const studioMap = new Map(this.studios.map(s => [s.Id, s]));
      const studioNameMap = new Map(this.studios.map(s => [s.Name, s.Id]));
      
      if(this.studios && !deferEntityFilters)
      {
        for (const studioNameSlug of studioNameSlugArray) {
          var studioIdTemp : number = parseInt(studioNameSlug);
          if(Number.isNaN(studioIdTemp))
          {
            var studioName : string = Utils.reverseSlug(studioNameSlug);
            const studioId = studioNameMap.get(studioName);
            if (studioId) {
              this.filterModel.StudioIds.push(studioId);
            }
          }
          else if(studioIdTemp > 0 && studioMap.has(studioIdTemp))
          {
            this.filterModel.StudioIds.push(studioIdTemp);
          }
        }
      }

      if (this.instructors && !deferEntityFilters) {
        this.filterModel.InstructorIds = resolveInstructorIdsFromTokens(
          instructorNameSlugArray,
          this.instructors
        );
      }

      // Address filters apply only while the host schedule is selected.
      if (this.addresses && selectionIncludesHost(this.filterModel.PartnerKey)) {
        for (const addressId of addressArray) {
          this.filterModel.AddressIds.push(addressId);
        }
      }

      // Load locations and validate/update location filter
      this.facilityService.getLocations().then(locations => {
        this.locations = locations;
        // Validate that the LocationId we set early actually exists in the locations
        if (this.filterModel.LocationId > 0 && !locations.some(loc => loc.Id === this.filterModel.LocationId)) {
          // LocationId doesn't exist, reset it
          this.filterModel.LocationId = 0;
        }
        // If we don't have a valid LocationId yet, try to set it from URL param or member
        if (this.filterModel.LocationId === 0) {
          if (locationIdParam > 0 && locations.some(loc => loc.Id === locationIdParam)) {
            this.filterModel.LocationId = locationIdParam;
          } else if (this.currentMember && this.currentMember.LocationId && this.currentMember.LocationId > 0) {
            // If no location in URL, use member's default LocationId if logged in
            if (locations.some(loc => loc.Id === this.currentMember.LocationId)) {
              this.filterModel.LocationId = this.currentMember.LocationId;
            }
          }
        }
        
        // Determine which locationId to use for API call
        let apiLocationId = this.locationId;
        if (this.filterModel.LocationId > 0) {
          apiLocationId = this.filterModel.LocationId;
        } else if (this.locationId === 0 || this.locationId === 1) {
          // Use default location from localStorage if available
          const storedLocation = this.localStorageService.getLocation();
          if (storedLocation && storedLocation.Id) {
            apiLocationId = storedLocation.Id;
          }
        }

        const requestPartners = this.sharedScheduleAllowed;
        const studioIdsForApi = requestPartners || this.filterModel.PartnerKey ? [] : apiStudioIds(this.filterModel.StudioIds);
        const instructorIdsForApi = requestPartners || this.filterModel.PartnerKey ? [] : this.filterModel.InstructorIds;
        const addressIdsForApi = requestPartners ? [] : this.filterModel.AddressIds;
        this._classesService.getPublicSessions(studioIdsForApi, instructorIdsForApi, addressIdsForApi, apiLocationId, requestPartners)
        .pipe(
          takeUntil(this._unsubscribe)
        )
        .subscribe({
          next: (sessions) => {
            this.allSessions = (sessions as Session[]) || [];
            this.applyPartnerScheduleView();
            if (deferEntityFilters) {
              this.applySlugFilters(this.pendingStudioSlugs, this.pendingInstructorSlugs);
              this.applyPartnerScheduleView();
            }

            if(this.sessions && this.sessions.length > 0)
            {
              this.firstVisibleSession = this.sessions[0];
            }
            
            const dateToRestore = this.getScheduleDateToRestore();
            this.setCurrentDate(dateToRestore);
            this.getSlides(dateToRestore);
            this.processSessions(dateToRestore);
            this.refreshWaitlistStatuses();
            this.cdr.markForCheck();
          },
          error: (error) => {
            this.logService.error("Error loading sessions", error);
          }
        });
      });
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.sendBodyHeight();
  }

  sendBodyHeight() {
    const observer = new ResizeObserver(() => {
      const bodyH = this.el.nativeElement.ownerDocument.body.offsetHeight;
      if (this.bodyHeight !== bodyH) {
        this.bodyHeight = bodyH;
        window.parent.postMessage({ frameHeight: this.bodyHeight }, '*');
      }
    });

    observer.observe(this.el.nativeElement.ownerDocument.body);
  }

  jumpToDateInUI(dateTime?: string, manageScrollSync: boolean = true)
  {
    // Use provided dateTime or default to first visible session
    let targetDateYYYYMMDD: string;
    if (dateTime) {
      // Always use the provided dateTime, don't fall back to today
      targetDateYYYYMMDD = /^\d{4}-\d{2}-\d{2}$/.test(dateTime)
        ? dateTime
        : Utils.formatDateInTimezone(dateTime, this.getScheduleTimeZone());
      // Find the first session for this date in filteredSessions (could be header or actual session)
      if (this.filteredSessions && this.filteredSessions.length > 0) {
        const targetSession = this.filteredSessions.find(session => 
          this.getSessionDateString(session) === targetDateYYYYMMDD
        );
        if (targetSession) {
          this.firstVisibleSession = targetSession;
        }
        // Don't fallback - we want to scroll to the dateTime even if no session found yet
      }
    } else if (this.filteredSessions && this.filteredSessions.length > 0) {
      this.firstVisibleSession = this.filteredSessions[0];
      targetDateYYYYMMDD = this.getSessionDateString(this.firstVisibleSession);
    } else {
      return;
    }

    // Always set the current date to the target date (dateTime parameter), not today
    this.currentDateYYYYMMDD = targetDateYYYYMMDD;
    this.currentDateStr = moment(targetDateYYYYMMDD, 'YYYY-MM-DD').format('dddd, MMMM DD');
    this.setPaginationToDate(this.currentDateYYYYMMDD);

    var slideIndexToSet = 1; // The index of the slide you want to set
    this.slides.forEach((slide: any, i: number) => {
      if(slide.DateTime == this.currentDateYYYYMMDD)
      {
        slide.IsCurrent = true;
        slideIndexToSet = i;
        // Set the active slide
        if(this.slickCarousel) {
          this.slickCarousel.slickGoTo(slideIndexToSet);
          this.lastSlideIndex = slideIndexToSet;
          setTimeout(() => {
            this.updateArrowStates();
          }, 100);
        }
      } else {
        slide.IsCurrent = false;
      }
    });

    const scrollBehavior: ScrollBehavior = manageScrollSync ? 'smooth' : 'auto';

    // Wait for DOM to update before scrolling
    setTimeout(() => {
      const scrollToSelector = `.session-${targetDateYYYYMMDD}`;
      const elements = document.querySelectorAll(scrollToSelector);
      
      if (elements.length === 0) {
        if (manageScrollSync) {
          this.disableScrollEvent = false;
        }
        return;
      }
      
      // Prefer header row if it exists, otherwise use first session
      let element: HTMLElement | null = null;
      for (let i = 0; i < elements.length; i++) {
        const el = elements[i] as HTMLElement;
        if (el.classList.contains('header')) {
          element = el;
          break;
        }
      }
      
      if (!element && elements.length > 0) {
        element = elements[0] as HTMLElement;
      }
      
      if (element) {
        // Use scrollIntoView to bring element into view
        element.scrollIntoView({ 
          behavior: scrollBehavior, 
          block: 'center',
          inline: 'nearest'
        });
        
        // Also scroll window to element position with offset
        const elementRect = element.getBoundingClientRect();
        const elementTopRelativeToWindow = elementRect.top + window.scrollY;
        const targetWindowScroll = elementTopRelativeToWindow - 250;
        
        window.scrollTo({
          top: Math.max(0, targetWindowScroll),
          behavior: scrollBehavior
        });
        
        if (manageScrollSync) {
          setTimeout(() => {
            this.disableScrollEvent = false;
          }, 1000);
        }
      } else if (manageScrollSync) {
        this.disableScrollEvent = false;
      }
    }, 300);
  }

  //Pagination
  onDateSelect(dateTime: string) {
    if (!dateTime) {
      return;
    }
    const selectedDateStr = /^\d{4}-\d{2}-\d{2}$/.test(dateTime)
      ? dateTime
      : Utils.getSessionCalendarDateString(dateTime);
    // Past days are not selectable
    const slide = this.slides?.find((s: { DateTime: string }) => s.DateTime === selectedDateStr);
    if (slide?.IsDisabled) {
      return;
    }

    this.persistSelectedDate(selectedDateStr);
    this.setCurrentDate(selectedDateStr);
    // Update carousel selection immediately (don't wait for scroll jump)
    this.slides?.forEach((s: { DateTime: string; IsCurrent: boolean }) => {
      s.IsCurrent = s.DateTime === selectedDateStr;
    });

    this.disableScrollEvent = true;
    // Don't reset scroll to 0 - we want to scroll to the selected date instead

    const targetDate = this.getTodayInScheduleTimeZone();
    const todayMoment = moment(targetDate, 'YYYY-MM-DD').startOf('day');
    const selectedDateMoment = moment(selectedDateStr, 'YYYY-MM-DD').startOf('day');
    
    // Find sessions starting from today's date, but ensure we include sessions up to the selected date
    let startIndex = -1;
    let endIndex = -1;
    
    // Find start index (from today)
      for (let i = 0; i < this.sessions.length; i++) {
      const sessionDate = moment(this.getSessionDateString(this.sessions[i]), 'YYYY-MM-DD').startOf('day');
      if (startIndex === -1 && sessionDate.isSameOrAfter(todayMoment, 'day')) {
        startIndex = i;
        break;
      }
    }
    
    // Find end index (up to selected date + some buffer to ensure we have sessions for that date)
    if (startIndex !== -1) {
      // Search through ALL sessions to find the selected date (not just limited range)
      let selectedDateFoundIndex = -1;
      for (let i = startIndex; i < this.sessions.length; i++) {
        const sessionDate = moment(this.getSessionDateString(this.sessions[i]), 'YYYY-MM-DD').startOf('day');
        if (sessionDate.isSameOrAfter(selectedDateMoment, 'day')) {
          selectedDateFoundIndex = i;
          break;
        }
      }
      
      if (selectedDateFoundIndex !== -1) {
        // Found the selected date - load enough sessions to include it with buffer
        endIndex = Math.min(selectedDateFoundIndex + 20, this.sessions.length);
      } else {
        // Selected date not found in sessions (might be too far in future)
        // Load default limit, but also check if we need to load more
        endIndex = Math.min(startIndex + this.sessionLimit, this.sessions.length);
      }
    }
    
    if (startIndex !== -1) {
      var nextSessions: Session[] = this.sessions.slice(startIndex, endIndex);
      // Use optimized filtering
      const startTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.StartTime)}:00:00`).getTime();
      const endTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.EndTime)}:00:00`).getTime();
      
      var filteredSessions: Session[] = [];
      for (const session of nextSessions) {
        if (Utils.isSessionStartInPastInTimezone(
          session.StartDate,
          session.StartTime,
          this.getSessionTimeZone(session)
        )) {
          continue;
        }
        
        const sessionTime = new Date(`1970-01-01T${session.StartTime}`).getTime();
        if (sessionTime < startTimeRange || sessionTime > endTimeRange) continue;
        
        // Check location filter
        if (this.filterModel.LocationId > 0 && session.LocationId !== this.filterModel.LocationId) {
          continue;
        }
        if (!this.sessionMatchesClientFilters(session)) {
          continue;
        }
        
        filteredSessions.push(session);
      }
      
      this.filteredSessions = filteredSessions;
      this.addDayRows(selectedDateStr);
      
      // Show button if there are more sessions available after endIndex
      // Check if we've reached the end of all sessions
      const hasMoreSessions = endIndex < this.sessions.length;
      
      // Hide button if no sessions were found or if we've reached the end
      if(filteredSessions.length === 0 || !hasMoreSessions) {
        this.showLoadMore = false;
      } else {
        this.showLoadMore = true;
      }
    } else {
      this.showLoadMore = false;
    }

    // Wait for change detection and DOM update before jumping
    this.cdr.markForCheck();
    // Use multiple timeouts to ensure DOM is fully rendered
    setTimeout(() => {
      this.cdr.detectChanges();
      setTimeout(() => {
        // Jump to the dateTime parameter passed in
        this.jumpToDateInUI(selectedDateStr);
      }, 100);
    }, 0);
  }

  calculateFilterCount(): void {
    this.filterCount = 0;
    // Count total number of selected items across all filter categories
    this.filterCount += this.filterModel.InstructorIds.length;
    this.filterCount += this.filterModel.StudioIds.length;
    // Only count addresses if not all are selected (i.e., a filter is actually applied)
    if(this.filterModel.AddressIds.length != this.addresses.length) 
    {
      this.filterCount += this.filterModel.AddressIds.length;
    }
    // Count time filter as 1 if it's been changed from default
    if (this.filterModel.StartTime !== CLASS_FILTER_DEFAULT_START_TIME || this.filterModel.EndTime !== CLASS_FILTER_DEFAULT_END_TIME) {
      this.filterCount++;
    }
    this.filterCount += parseScheduleSelection(this.filterModel.PartnerKey).partnerKeys.length;
    // if (this.filterModel.LocationId > 0) this.filterCount++;
  }

  setPaginationToDate(dateTime: string) {
    this.setCurrentDate(dateTime);
    $(".date.current").removeClass("current");
    $(".date-paginator-slider").find("[data-datetime='" + dateTime + "']").addClass("current");
  }

  slickInit(e : any) {
    setTimeout(() => {
      this.setRange();
      this.updateArrowStates();
    }, 100);
  }
  
  afterChange(e : any) {
    this.setRange();
    this.updateArrowStates();
  }

  updateArrowStates(): void {
    if (!this.slickCarousel || !this.slides || this.slides.length === 0) {
      this.canGoPrev = false;
      this.canGoNext = false;
      return;
    }

    try {
      // Get current slide index from slick instance
      const slickInstance = (this.slickCarousel as any).slick;
      if (slickInstance) {
        const currentSlide = slickInstance.currentSlide || 0;
        const slidesToShow = this.slideConfig.slidesToShow || 7;
        const totalSlides = this.slides.length;

        // Can go previous if not at the start
        this.canGoPrev = currentSlide > 0;

        // Can go next if not at the end
        this.canGoNext = currentSlide + slidesToShow < totalSlides;
      } else {
        // Fallback: check if we're at the beginning or end based on active slides
        const activeSlides = document.querySelectorAll('.slide.slick-active');
        if (activeSlides.length > 0) {
          const firstActive = activeSlides[0] as HTMLElement;
          const lastActive = activeSlides[activeSlides.length - 1] as HTMLElement;
          
          // Check if first active slide is the first slide
          const firstSlideIndex = Array.from(document.querySelectorAll('.slide')).indexOf(firstActive);
          this.canGoPrev = firstSlideIndex > 0;

          // Check if last active slide is the last slide
          const allSlides = document.querySelectorAll('.slide');
          const lastSlideIndex = Array.from(allSlides).indexOf(lastActive);
          this.canGoNext = lastSlideIndex < allSlides.length - 1;
        }
      }
    } catch (e) {
      // Fallback to false if we can't determine state
      this.canGoPrev = false;
      this.canGoNext = false;
    }
  }

  goToPrev(): void {
    if (this.canGoPrev && this.slickCarousel) {
      this.slickCarousel.slickPrev();
    }
  }

  goToNext(): void {
    if (this.canGoNext && this.slickCarousel) {
      this.slickCarousel.slickNext();
    }
  }

  setCurrentDate(dateTime: string){
    const calendarDate = /^\d{4}-\d{2}-\d{2}$/.test(dateTime)
      ? dateTime
      : Utils.getSessionCalendarDateString(dateTime);
    const currentMomentDate = moment(calendarDate, 'YYYY-MM-DD');
    this.date = calendarDate;
    this.currentDate = currentMomentDate.toDate();
    this.currentDateYYYYMMDD = calendarDate;
    this.currentDateStr = currentMomentDate.format('dddd, MMMM DD');
  }

  /** Syncs the date carousel to a facility calendar day (YYYY-MM-DD). */
  private applyCalendarDate(dateStr: string, session?: Session): void {
    if (!dateStr || dateStr === this.currentDateYYYYMMDD) {
      return;
    }
    if (session && session.Id > 0) {
      this.firstVisibleSession = session;
    }
    this.currentDateYYYYMMDD = dateStr;
    this.currentDateStr = moment(dateStr, 'YYYY-MM-DD').format('dddd, MMMM DD');
    this.setPaginationToDate(dateStr);

    let slideIndexToSet = -1;
    this.slides.forEach((slide: any, i: number) => {
      if (slide.DateTime === dateStr) {
        slide.IsCurrent = true;
        slideIndexToSet = i;
      } else {
        slide.IsCurrent = false;
      }
    });

    if (slideIndexToSet >= 0 && this.slickCarousel && slideIndexToSet !== this.lastSlideIndex) {
      try {
        this.slickCarousel.slickGoTo(slideIndexToSet);
        this.lastSlideIndex = slideIndexToSet;
        setTimeout(() => this.updateArrowStates(), 100);
      } catch {
        // Carousel may not be ready during fast scrolling
      }
    }
  }

  setRange() {
    this.rangeStart = $(".slide.slick-active:first").data("month") + " " + $(".slide.slick-active:first").data("date");
    this.rangeEnd = $(".slide.slick-active:last").data("month") + " " + $(".slide.slick-active:last").data("date");
  }

  /** Format helpers for carousel slides — always parse as civil YYYY-MM-DD (no TZ shift). */
  private getSlideDateParts(dateTime: string): { month: string; date: string; day: string } {
    if (!this.dateFormatCache.has(dateTime)) {
      const calendarDate = /^\d{4}-\d{2}-\d{2}$/.test(dateTime)
        ? dateTime
        : Utils.getSessionCalendarDateString(dateTime);
      const momentDate = moment(calendarDate, 'YYYY-MM-DD');
      this.dateFormatCache.set(dateTime, {
        month: momentDate.format('MMM'),
        date: momentDate.format('D'),
        day: momentDate.format('dd'),
      });
    }
    return this.dateFormatCache.get(dateTime)!;
  }

  getMonth(dateTime: string) {
    return this.getSlideDateParts(dateTime).month;
  }

  getDate(dateTime: string) {
    return this.getSlideDateParts(dateTime).date;
  }

  getDay(dateTime: string) {
    return this.getSlideDateParts(dateTime).day;
  }

  getSlides(selectedDateYYYYMMDD?: string) {
    if(this.sessions && this.sessions.length > 0)
    {
      const sessionDateStrings = this.sessions.map((session) =>
        this.getSessionDateString(session)
      );
      const minDateStr = sessionDateStrings.reduce((min, d) => (d < min ? d : min));
      const maxDateStr = sessionDateStrings.reduce((max, d) => (d > max ? d : max));

      this.slides = [];
      moment.updateLocale('en', {
          week : {
              dow :0  // 0 to 6 sunday to saturday
          }
      });
      let fromDate : moment.Moment = moment(minDateStr, 'YYYY-MM-DD').startOf('week');
      let fromDateStr : string = fromDate.format("YYYY-MM-DD");
      let toDate : moment.Moment = moment(maxDateStr, 'YYYY-MM-DD').endOf('week');
      const facilityToday = this.getTodayInScheduleTimeZone();
      const highlightDateStr = selectedDateYYYYMMDD || facilityToday;
      let type : moment.unitOfTime.Diff = "days";
      let diff = toDate.diff(fromDate, type);
      for (let i = 0; i <= diff; i++) {
        let date = moment(fromDateStr).add(i, type);
        let dateStr = date.format("YYYY-MM-DD");
        this.slides.push(
          {
            "DateTime": dateStr,
            "IsDisabled": dateStr < facilityToday,
            "IsCurrent": dateStr === highlightDateStr
          }
        );
      }
      this.setCurrentDate(highlightDateStr);
    }
  }

  // Load bookings - can be called from ngOnInit or ngAfterViewInit
  private loadBookings(forceRefresh: boolean = false): void {
    if (this.memberId > 0) {
      this._user.fetchMemberAccount(forceRefresh)?.pipe(
        takeUntil(this._unsubscribe),
        tap((memberAccount: any) => {
          this.bookings = (memberAccount.Upcoming.ClassBookings || []).filter((cb: any) => {
            return cb.MemberId === memberAccount.Id;
          });
          // Create Set for O(1) lookup performance
          // Handle both number and string types, and filter out cancelled bookings
          const sessionIds = (this.bookings || [])
            .filter((b: any) => {
              // Filter out cancelled bookings if they have a CancelledAt field
              if (b.CancelledAt && b.CancelledAt !== '0001-01-01T00:00:00' && b.CancelledAt !== null) {
                return false;
              }
              return b.SessionId != null && b.SessionId !== undefined;
            })
            .map((b: any) => Number(b.SessionId)); // Convert to number for consistent comparison
          
          this.bookingsSet = new Set(sessionIds);          
          this.refreshWaitlistStatuses();
          this.cdr.markForCheck();
        }),
        catchError((error: any) => {
          this.logService.error("MemberAccount error", error);
          return of(null);
        })
      ).subscribe();
    }
  }

  //Sessions
  ngAfterViewInit(): void {
    // Load bookings as early as possible
    this.loadBookings();
    this.sendBodyHeight();
    setTimeout(() => {
      this.sendBodyHeight();
    }, 1000);
  }

  isSupported(): boolean {
    return this._featureSupport.isSupported('reserve');
  }

  isInFuture(session: Session): boolean {
    return Utils.isSessionStartInFutureInTimezone(
      session.StartDate,
      session.StartTime,
      this.getSessionTimeZone(session)
    );
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    if(this.disableScrollEvent)
      return;
    
    // Throttle scroll events for better performance
    if (this.scrollThrottleTimer) {
      return;
    }

    this.scrollThrottleTimer = setTimeout(() => {
      this.handleScroll();
      this.scrollThrottleTimer = null;
    }, 50); // Throttle to ~20fps for smooth updates

    // Track scrolling state
    this.isScrolling = true;
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.isScrolling = false;
      // Final update when scrolling stops
      this.handleScroll();
    }, 150);
  }

  private handleScroll(): void {
    var currentYCoordinate = window.scrollY;
    const container = document.querySelector('#sessionsWrapper');
    const paginatorContainer = document.querySelector('.page-paginator-wrapper');
    const footer = document.querySelector('.footer-area');
    const nav = document.querySelector('.navbar-area');
    const filtersWrapper = this.el.nativeElement.querySelector('.filters');
    
    const listItems = document.querySelectorAll('.sessions-wrapper .session-wrapper');
    
    // Handle filter positioning
    if(container && paginatorContainer && footer && nav)
    {
      var height = container.getBoundingClientRect().height + paginatorContainer.getBoundingClientRect().height + nav.getBoundingClientRect().height - (footer.getBoundingClientRect().height * 2);
      if(currentYCoordinate > height)
      {
        this.renderer.addClass(filtersWrapper, 'absolute');
        this.renderer.removeClass(filtersWrapper, 'fixed');
      } else {
        this.renderer.addClass(filtersWrapper, 'fixed');
        this.renderer.removeClass(filtersWrapper, 'absolute');
      }
    }

    // Sync calendar to the date header that has scrolled up to the sticky paginator
    if (container && paginatorContainer && listItems.length > 0 && this.filteredSessions) {
      const containerTop = paginatorContainer.getBoundingClientRect().bottom;
      let activeHeaderDate: string | null = null;

      for (let i = 0; i < listItems.length; i++) {
        const listItem = listItems[i] as HTMLElement;
        const session = this.filteredSessions[i];
        if (!listItem.classList.contains('header') || !session || session.Id !== 0) {
          continue;
        }
        if (listItem.getBoundingClientRect().top <= containerTop + 5) {
          activeHeaderDate = this.getSessionDateString(session);
        }
      }

      if (activeHeaderDate) {
        this.applyCalendarDate(activeHeaderDate);
      }
    }
  }

  onLoadMore() {
    this.disableScrollEvent = true;
    var lastSession: Session | undefined;
    if (this.filteredSessions && this.filteredSessions.length > 0) {
      // Find the last actual session (Id > 0), not a header
      for (let i = this.filteredSessions.length - 1; i >= 0; i--) {
        if (this.filteredSessions[i].Id > 0) {
          lastSession = this.filteredSessions[i];
          break;
        }
      }

      if (lastSession) {
        const startIndex = this.sessions.findIndex(session => session.Id === lastSession!.Id);

        if (startIndex !== -1) {
          var nextSessions: Session[] = this.sessions.slice(startIndex + 1, startIndex + (this.sessionLimit + 1));

          const startTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.StartTime)}:00:00`).getTime();
          const endTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.EndTime)}:00:00`).getTime();
          
          var newFilteredSessions: Session[] = [];
          for (const session of nextSessions) {
            if (Utils.isSessionStartInPastInTimezone(
              session.StartDate,
              session.StartTime,
              this.getSessionTimeZone(session)
            )) {
              continue;
            }
            
            const sessionTime = new Date(`1970-01-01T${session.StartTime}`).getTime();
            if (sessionTime < startTimeRange || sessionTime > endTimeRange) continue;
            
            // Check location filter
            if (this.filterModel.LocationId > 0 && session.LocationId !== this.filterModel.LocationId) {
              continue;
            }
            if (!this.sessionMatchesClientFilters(session)) {
              continue;
            }
            
            newFilteredSessions.push(session);
          }
          
          this.filteredSessions = this.filteredSessions.concat(newFilteredSessions);
          this.addDayRows();
          
          // Check if there are more sessions available after the current batch
          const nextBatchStartIndex = startIndex + 1 + this.sessionLimit;
          const hasMoreSessions = nextBatchStartIndex < this.sessions.length;
          
          // Hide button if no new sessions were added or if we've reached the end
          if(newFilteredSessions.length === 0 || !hasMoreSessions) {
            this.showLoadMore = false;
          }
        } else {
          this.showLoadMore = false;
        }
      } else {
        // No actual sessions found, hide the button
        this.showLoadMore = false;
      }
    } else {
      this.showLoadMore = false;
    }
    this.cdr.markForCheck();
    this.disableScrollEvent = false;
  }

  addDayRows(ensureHeaderDate?: string) {
    var updatedSessions : Session[] = [];
    if (this.filteredSessions && this.filteredSessions.length > 0) {
      // Get all actual sessions (Id > 0) grouped by date
      const sessionsByDate = new Map<string, Session[]>();
      let minDateStr: string | null = null;
      let maxDateStr: string | null = null;
      
      // Group sessions by date and find date range
      this.filteredSessions.forEach((session: Session) => {
        if (session.Id > 0) {
          const dateKey = this.getSessionDateString(session);
          if (!sessionsByDate.has(dateKey)) {
            sessionsByDate.set(dateKey, []);
          }
          sessionsByDate.get(dateKey)!.push(session);
          
          if (minDateStr === null || dateKey < minDateStr) {
            minDateStr = dateKey;
          }
          if (maxDateStr === null || dateKey > maxDateStr) {
            maxDateStr = dateKey;
          }
        }
      });
      
      // If we have a date range, add headers for all dates in the range
      if (minDateStr !== null && maxDateStr !== null) {
        const currentDate = moment(minDateStr, 'YYYY-MM-DD');
        const maxDateMoment = moment(maxDateStr, 'YYYY-MM-DD');
        while (currentDate.isSameOrBefore(maxDateMoment, 'day')) {
          const dateKey = currentDate.format("YYYY-MM-DD");
          
          // Always add header for this date
          updatedSessions.push(this.getEmptySession(dateKey));
          
          // Add sessions for this date if any exist
          const sessionsForDate = sessionsByDate.get(dateKey);
          if (sessionsForDate) {
            sessionsForDate.forEach(session => {
              updatedSessions.push(session);
            });
          }
          
          // Move to next day
          currentDate.add(1, 'day');
        }
      } else {
        // Fallback to original logic if no date range found
        var currentDateKey: string | null = null;
        this.filteredSessions.forEach((session: Session) => {
          const dateKey = this.getSessionDateString(session);
          if (currentDateKey) {
            if (currentDateKey !== dateKey) {
              updatedSessions.push(this.getEmptySession(dateKey));
              currentDateKey = dateKey;
            }
          } else {
            currentDateKey = dateKey;
          }
          updatedSessions.push(session);
        });
      }

      if (ensureHeaderDate && /^\d{4}-\d{2}-\d{2}$/.test(ensureHeaderDate)) {
        const firstHeaderDate =
          updatedSessions.length > 0 && updatedSessions[0].Id === 0
            ? this.getSessionDateString(updatedSessions[0])
            : null;
        if (!firstHeaderDate || ensureHeaderDate < firstHeaderDate) {
          updatedSessions.unshift(this.getEmptySession(ensureHeaderDate));
        }
      }
    }
    this.filteredSessions = updatedSessions;
  }

  getEmptySession(dateStr: string): Session
  {
    // Keep StartDate as YYYY-MM-DD string — converting via moment().toDate() then
    // getSessionCalendarDateString (UTC) shifts the day back for timezones east of UTC (DFS-1497).
    var session: Session = {
      Id: 0,
      LocationId: 0,
      LocationName: '',
      AddressId: null,
      AddressName: '',
      StudioName: '',
      StudioImageUrl: '',
      ClassName: '',
      Theme: '',
      InstructorName: '',
      InstructorImageUrl: '',
      StartDate: dateStr as unknown as Date,
      StartTime: '',
      EndTime: '',
      Duration: 0,
      TotalSpots: 0,
      SpotsBooked: 0,
      SpotsLeft: 0
    }
    return session;
  }

  getTimeText(sessionOrTime: { StartDate?: Date | string; StartTime?: string; LocationId?: number } | string)
  {
    // Legacy: time-only string (facility wall clock, no conversion).
    if (typeof sessionOrTime === 'string') {
      if (!this.sessionTimeCache.has(sessionOrTime)) {
        const label = moment("0001-01-01 " + sessionOrTime).format("h:mm A");
        const abbr = Utils.getShortTimeZoneName();
        this.sessionTimeCache.set(sessionOrTime, abbr ? `${label} ${abbr}` : label);
      }
      return this.sessionTimeCache.get(sessionOrTime)!;
    }

    const startDate = sessionOrTime.StartDate;
    const startTime = sessionOrTime.StartTime ?? '';
    const sessionTimeZone = this.getSessionTimeZone(sessionOrTime);
    const cacheKey = `${Utils.getSessionCalendarDateString(startDate)}|${startTime}|${sessionTimeZone}`;
    if (!this.sessionTimeCache.has(cacheKey)) {
      const instant = Utils.combineSessionDateAndTime(
        startDate ?? '',
        startTime,
        sessionTimeZone
      );
      const label = instant.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' });
      const abbr = Utils.getShortTimeZoneName(instant);
      this.sessionTimeCache.set(cacheKey, abbr ? `${label} ${abbr}` : label);
    }
    return this.sessionTimeCache.get(cacheKey)!;
  }

  getDateText(date: Date | string)
  {
    return moment(Utils.getSessionCalendarDateString(date), 'YYYY-MM-DD').format('dddd, MMMM DD');
  }

  getMilitaryDateText(date: Date | string)
  {
    return Utils.getSessionCalendarDateString(date);
  }

  getDayText(date: Date | string)
  {
    return moment(Utils.getSessionCalendarDateString(date), 'YYYY-MM-DD').format('ddd').toUpperCase();
  }

  get hostScheduleLabel(): string {
    const location = this.locations?.find(loc => loc.Id === this.filterModel.LocationId);
    return location?.Name || this._environmentService.getFacilityConfig().name || 'This studio';
  }

  isPartnerSession(session: Session): boolean {
    return isPartnerArtifact(session);
  }

  venueName(session: Session): string {
    return sessionVenueName(session);
  }

  onSessionRowClick(session: Session): void {
    if (!session || session.Id <= 0) {
      return;
    }
    if (isPartnerArtifact(session)) {
      this.alertService.info(PARTNER_BOOKING_UNAVAILABLE_MESSAGE);
      return;
    }
    this.goToSession(session.Id);
  }

  showPartnerBookingNotice(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.alertService.info(PARTNER_BOOKING_UNAVAILABLE_MESSAGE);
  }

  isHostScheduleSelected(): boolean {
    return selectionIncludesHost(this.filterModel.PartnerKey);
  }

  isPartnerLocationSelected(key: string): boolean {
    return parseScheduleSelection(this.filterModel.PartnerKey).partnerKeys.includes(key);
  }

  selectHostSchedule(): void {
    const next = formatScheduleSelection(
      toggleHostInSelection(parseScheduleSelection(this.filterModel.PartnerKey))
    );
    if (next === this.filterModel.PartnerKey) {
      return;
    }
    this.filterModel.PartnerKey = next;
    window.location.href = this.generateUrl();
  }

  selectPartnerLocation(key: string): void {
    const next = formatScheduleSelection(
      togglePartnerInSelection(parseScheduleSelection(this.filterModel.PartnerKey), key)
    );
    if (next === this.filterModel.PartnerKey) {
      return;
    }
    this.filterModel.PartnerKey = next;
    window.location.href = this.generateUrl();
  }

  private sessionMatchesClientFilters(session: Session): boolean {
    if (!this.sharedScheduleAllowed) {
      return !isPartnerArtifact(session);
    }

    const selection = parseScheduleSelection(this.filterModel.PartnerKey);
    const partner = isPartnerArtifact(session);
    if (partner) {
      if (!selection.partnerKeys.includes(partnerScheduleKey(session))) {
        return false;
      }
    } else if (!selection.includeHost) {
      return false;
    }

    if (this.filterModel.StudioIds.length > 0) {
      if (partner) {
        if (!this.filterModel.StudioIds.includes(Number(session.FilterStudioId))) {
          return false;
        }
      } else {
        const selectedNames = new Set(
          this.hostStudios
            .filter(studio => this.filterModel.StudioIds.includes(studio.Id))
            .map(studio => studio.Name)
        );
        if (selectedNames.size === 0 || !selectedNames.has(session.StudioName)) {
          return false;
        }
      }
    }

    if (this.filterModel.InstructorIds.length > 0 && !this.filterModel.InstructorIds.includes(Number(session.InstructorId))) {
      return false;
    }

    if (
      !partner &&
      this.filterModel.AddressIds.length > 0 &&
      !this.filterModel.AddressIds.includes(Number(session.AddressId))
    ) {
      return false;
    }
    return true;
  }

  private applyPartnerScheduleView(): void {
    const hostLocationId = this.filterModel.LocationId || this.locationId || 1;
    if (!this.sharedScheduleAllowed) {
      this.partnerLocations = [];
      this.studioByPartner = {};
      this.instructorsByPartner = {};
      this.filterModel.PartnerKey = '';
      this.sessions = excludePartnerArtifacts(this.allSessions);
      this.studios = this.hostStudios;
      this.instructors = this.hostInstructors;
      return;
    }

    this.partnerLocations = partnerLocationsForViewer(this.allSessions, true);
    const studios: { [key: string]: Studio } = {};
    const instructors: { [key: string]: InstructorDetails[] } = {};
    for (const option of this.partnerLocations) {
      studios[option.key] = syntheticStudioForPartner(option, hostLocationId);
      instructors[option.key] = instructorsFromPartnerSessions(
        sessionsForScheduleView(this.allSessions, { includeHost: false, partnerKeys: [option.key] })
      );
    }
    this.studioByPartner = studios;
    this.instructorsByPartner = instructors;

    const requested = parseScheduleSelection(this.filterModel.PartnerKey);
    const validKeys = new Set(this.partnerLocations.map(option => option.key));
    this.filterModel.PartnerKey = formatScheduleSelection({
      includeHost: requested.includeHost,
      partnerKeys: requested.partnerKeys.filter(key => validKeys.has(key)),
    });

    this.studios = studiosForScheduleSelection(this.hostStudios, this.studioByPartner, this.filterModel.PartnerKey);
    this.instructors = instructorsForScheduleSelection(
      this.hostInstructors,
      this.instructorsByPartner,
      this.filterModel.PartnerKey
    );
    this.sessions = sessionsForScheduleView(this.allSessions, this.filterModel.PartnerKey)
      .map(row => {
        if (!isPartnerArtifact(row)) {
          return row;
        }
        const studio = studios[partnerScheduleKey(row)];
        return studio ? { ...row, FilterStudioId: studio.Id } : row;
      })
      .filter(session => this.sessionMatchesClientFilters(session))
      .sort((a, b) => this.compareSessions(a, b));
  }

  private compareSessions(a: Session, b: Session): number {
    const dateA = this.getSessionDateString(a);
    const dateB = this.getSessionDateString(b);
    if (dateA !== dateB) {
      return dateA < dateB ? -1 : 1;
    }
    if (a.StartTime !== b.StartTime) {
      return a.StartTime < b.StartTime ? -1 : 1;
    }
    return a.Id - b.Id;
  }

  private applySlugFilters(studioSlugs: string[], instructorSlugs: string[]): void {
    this.filterModel.StudioIds = [];
    this.filterModel.InstructorIds = [];
    const studioMap = new Map((this.studios || []).map(studio => [studio.Id, studio]));
    const studioNameMap = new Map((this.studios || []).map(studio => [studio.Name, studio.Id]));
    for (const studioNameSlug of studioSlugs) {
      const studioIdTemp = parseInt(studioNameSlug, 10);
      if (Number.isNaN(studioIdTemp)) {
        const studioId = studioNameMap.get(Utils.reverseSlug(studioNameSlug));
        if (studioId) {
          this.filterModel.StudioIds.push(studioId);
        }
      } else if (studioMap.has(studioIdTemp)) {
        this.filterModel.StudioIds.push(studioIdTemp);
      }
    }

    this.filterModel.InstructorIds = resolveInstructorIdsFromTokens(instructorSlugs, this.instructors);
  }

  goToSession(sessionId: number): void {
    if(sessionId <= 0)
      return;
    if (!this.isSupported()) return;
    
    // Store the calendar day so we can restore it when returning from class details
    const session = this.sessions.find(s => s.Id === sessionId);
    const dateToSave = this.currentDateYYYYMMDD
      || (session
        ? Utils.getSessionCalendarDateString(session.StartDate)
        : this.getTodayInScheduleTimeZone());
    this.persistSelectedDate(dateToSave);
    this.localStorageService.setProp(this.scheduleStorageCategory, 'returnToDate', dateToSave);
    
    if(this.isIframeRoute)
      this.router.navigate(['class-details-iframe', sessionId]);
    else
      this.router.navigate(['studio', 'class-details', sessionId]);
  }

  isLoggedIn(): boolean {
    this.currentMember = this.authService.getLoggedInMember();
    return !!this.currentMember;
  }

  /**
   * Handle the error
   * @param {*} error
   */
   _handleError(error: any) {
    // tslint:disable-next-line: prefer-const
    var errorMessage = error.message;
    return errorMessage;
  }

  private persistSelectedDate(dateTime: string): void {
    const normalized = /^\d{4}-\d{2}-\d{2}$/.test(dateTime)
      ? dateTime
      : Utils.formatDateInTimezone(dateTime, this.getScheduleTimeZone());
    this.localStorageService.setProp(
      this.scheduleStorageCategory,
      'selectedDate',
      normalized
    );
  }

  /** Restores the last selected calendar day (e.g. after back from class details). */
  private getScheduleDateToRestore(): string {
    const today = this.getTodayInScheduleTimeZone();
    const todayMoment = moment(today, 'YYYY-MM-DD').startOf('day');

    const returnToDate = this.localStorageService.getProperty<string>(
      this.scheduleStorageCategory,
      'returnToDate'
    );
    const selectedDate = this.localStorageService.getProperty<string>(
      this.scheduleStorageCategory,
      'selectedDate'
    );
    if (returnToDate) {
      this.localStorageService.deleteProp(this.scheduleStorageCategory, 'returnToDate');
    }

    const persistedRaw = returnToDate || selectedDate;
    if (!persistedRaw) {
      return today;
    }

    const persisted = Utils.getSessionCalendarDateString(persistedRaw) || persistedRaw;
    const persistedMoment = moment(persisted, 'YYYY-MM-DD').startOf('day');
    if (!persistedMoment.isValid() || persistedMoment.isBefore(todayMoment, 'day')) {
      this.localStorageService.deleteProp(this.scheduleStorageCategory, 'selectedDate');
      return today;
    }

    return persistedMoment.format('YYYY-MM-DD');
  }

  private processSessions(initialDate?: string): void {
    this.disableScrollEvent = true;
    const startTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.StartTime)}:00:00`).getTime();
    const endTimeRange = new Date(`1970-01-01T${this.getTwoDigitString(this.filterModel.EndTime)}:00:00`).getTime();
    
    // Single pass filtering for better performance
    var filteredSessions: Session[] = [];
    for (let i = 0; i < Math.min(this.sessions.length, this.sessionLimit); i++) {
      const session = this.sessions[i];
      
      if (Utils.isSessionStartInPastInTimezone(
        session.StartDate,
        session.StartTime,
        this.getSessionTimeZone(session)
      )) {
        continue;
      }
      
      // Check time range
      const sessionTime = new Date(`1970-01-01T${session.StartTime}`).getTime();
      if (sessionTime < startTimeRange || sessionTime > endTimeRange) continue;
      
      // Check location filter
      if (this.filterModel.LocationId > 0 && session.LocationId !== this.filterModel.LocationId) {
        continue;
      }
      if (!this.sessionMatchesClientFilters(session)) {
        continue;
      }
      
      filteredSessions.push(session);
    }
    
    this.filteredSessions = filteredSessions;
    const headerDate = initialDate || this.getTodayInScheduleTimeZone();
    this.addDayRows(headerDate);
    
    // Set showLoadMore based on whether there are more sessions to load
    if (filteredSessions.length === 0 || this.sessions.length <= this.sessionLimit) {
      this.showLoadMore = false;
    } else {
      this.showLoadMore = true;
    }
    
    // Use setTimeout to allow DOM to render before jumping
    setTimeout(() => {
      const today = this.getTodayInScheduleTimeZone();
      const restoreDate = initialDate || today;
      if (restoreDate !== today) {
        this.onDateSelect(restoreDate);
      } else {
        // Keep today selected; don't let scroll-sync override until initial layout settles
        this.jumpToDateInUI(restoreDate, false);
        setTimeout(() => {
          this.disableScrollEvent = false;
        }, 1200);
      }
      this.calculateFilterCount();
      this.cdr.markForCheck();
    }, 0);
  }

  isReserved(session: Session): boolean {
    if (!session || !session.Id) {
      return false;
    }
    
    // Check if bookings are loaded
    if (this.bookingsSet.size === 0 && this.bookings && this.bookings.length > 0) {
      // Rebuild set if it's empty but bookings exist (shouldn't happen, but safety check)
      const sessionIds = (this.bookings || []).map((b: any) => b.SessionId).filter((id: any) => id != null && id !== undefined);
      this.bookingsSet = new Set(sessionIds);
    }
    
    // Check both number and string versions in case of type mismatch
    const sessionIdNum = Number(session.Id);
    const isReserved = this.bookingsSet.has(session.Id) || this.bookingsSet.has(sessionIdNum);
    
    return isReserved;
  }

  isInWaitlist(session: Session): boolean {
    if (!session || !session.Id) {
      return false;
    }
    return this.waitlistSessionSet.has(Number(session.Id));
  }

  isWaitlistActionLoading(session: Session): boolean {
    if (!session || !session.Id) {
      return false;
    }
    return this.pendingWaitlistSessionSet.has(Number(session.Id));
  }

  onWaitlistActionClick(session: Session, event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    if (!session || !session.Id || session.SpotsLeft !== 0) {
      return;
    }

    const sessionId = Number(session.Id);
    if (this.pendingWaitlistSessionSet.has(sessionId)) {
      return;
    }

    if (!this.isLoggedIn()) {
      this.goToSession(session.Id);
      return;
    }

    const wasInWaitlist = this.isInWaitlist(session);
    this.pendingWaitlistSessionSet.add(sessionId);
    this.cdr.markForCheck();

    const request: Partial<SessionWaitlist> = {
      MemberId: this.memberId,
      SessionId: session.Id,
      Action: wasInWaitlist ? Action.Remove : Action.Add
    };

    const waitlistRequest$ = wasInWaitlist
      ? this.sessionWaitlistService.remove(request)
      : this.sessionWaitlistService.add(request);

    waitlistRequest$.pipe(takeUntil(this._unsubscribe)).subscribe({
      next: (result: boolean) => {
        if (!result) {
          this.alertService.error('Failed to update waitlist. Please try again.');
          this.pendingWaitlistSessionSet.delete(sessionId);
          this.cdr.markForCheck();
          return;
        }

        if (wasInWaitlist) {
          this.waitlistSessionSet.delete(sessionId);
          this.alertService.success('Removed from waitlist successfully.');
        } else {
          this.waitlistSessionSet.add(sessionId);
          this.alertService.success("You're on the waitlist!");
        }
        this.pendingWaitlistSessionSet.delete(sessionId);
        this.cdr.markForCheck();
      },
      error: () => {
        this.pendingWaitlistSessionSet.delete(sessionId);
        this.cdr.markForCheck();
        this.alertService.error('Failed to update waitlist. Please try again.');
      }
    });
  }

  getReservedSpot(session: Session): number | null {
    if (!session || !session.Id || !this.bookings || this.bookings.length === 0) {
      return null;
    }
    
    const sessionIdNum = Number(session.Id);
    const booking = this.bookings.find((b: any) => {
      const bookingSessionId = Number(b.SessionId);
      return bookingSessionId === session.Id || bookingSessionId === sessionIdNum;
    });
    
    return booking && booking.Spot ? booking.Spot : null;
  }

  screenAdoptedName(name: string): string {
    if (window.screen.availWidth < 768) {
      return name.split(' ')[0];
    }
    return name;
  }

  trackBySessionId(index: number, session: Session): number {
    return session.Id;
  }

  trackBySlideIndex(index: number, slide: any): string {
    return slide.DateTime;
  }

  spotsLeftText(session: Session): string {
    return `${session.SpotsLeft} spot${session.SpotsLeft !== 1 ? 's' : ''} left`;
  }

  filterSessions() : void {
    // Blur the trigger so focus is not on a descendant of aria-hidden when the modal opens (a11y).
    (document.activeElement as HTMLElement)?.blur?.();

    //open filter popup
    const modalRef = this.modalService.open(SessionFilterComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: false,
      windowClass: 'filter-popup-wrapper',
      modalDialogClass: 'filter-popup',
      fullscreen: window.innerWidth <= 768,
    });

    // Pass a copy so closing without saving (e.g. via X) does not persist unsaved Start time / other changes
    const filterModelCopy: FilterModel = {
      AddressIds: [...this.filterModel.AddressIds],
      StudioIds: [...this.filterModel.StudioIds],
      InstructorIds: [...this.filterModel.InstructorIds],
      LocationId: this.filterModel.LocationId,
      StartTime: this.filterModel.StartTime,
      EndTime: this.filterModel.EndTime,
      PartnerKey: this.filterModel.PartnerKey,
    };

    modalRef.componentInstance.filterConfig = this.filterConfig;
    modalRef.componentInstance.filterModel = filterModelCopy;
    modalRef.componentInstance.addresses = this.addresses;
    // Always pass host catalogs so the modal can switch partner→host and pick host filters
    // before Save; generateUrl resolves IDs from host + current + partner catalogs.
    modalRef.componentInstance.studios = this.hostStudios;
    modalRef.componentInstance.instructors = this.hostInstructors;
    modalRef.componentInstance.locations = this.locations;
    modalRef.componentInstance.partnerLocations = this.partnerLocations;
    modalRef.componentInstance.studioByPartner = this.studioByPartner;
    modalRef.componentInstance.instructorsByPartner = this.instructorsByPartner;
    modalRef.componentInstance.hostScheduleLabel = this.hostScheduleLabel;

    // Move focus into the modal when shown to avoid aria-hidden on a focused-ancestor (a11y).
    // Defer to next tick so focus runs after the modal is in the DOM and visible.
    // Focus the dialog container, not the close button, so Enter/Space does not dismiss the modal.
    modalRef.shown.pipe(take(1)).subscribe(() => {
      setTimeout(() => {
        const dialog =
          document.querySelector<HTMLElement>('.filter-popup-wrapper .modal-dialog') ??
          document.querySelector<HTMLElement>('.modal.show .modal-dialog');
        if (dialog) {
          dialog.setAttribute('tabindex', '-1');
          dialog.focus();
        }
      }, 0);
    });

    //Retrieving data from popup
    modalRef.result.then((result: FilterModel|boolean) => {
      if(typeof result != "boolean")
      {
        this.filterModel = result;
        this.calculateFilterCount();
        window.location.href = this.generateUrl();
      }
    }).catch(() => {
      // Modal dismissed (X, backdrop click, ESC) — no-op; filterModel unchanged
    });
  }

  generateUrl() : string
  {
    var studioSlugs : string[] = [];
    var instructorSlugs : string[] = [];
    const studioCatalog = new Map<number, Studio>();
    for (const studio of studiosForScheduleSelection(this.hostStudios, this.studioByPartner, this.filterModel.PartnerKey)) {
      studioCatalog.set(studio.Id, studio);
    }
    const instructorCatalog = new Map<number, InstructorDetails>();
    for (const instructor of instructorsForScheduleSelection(this.hostInstructors, this.instructorsByPartner, this.filterModel.PartnerKey)) {
      instructorCatalog.set(instructor.Id, instructor);
    }
    for (var studioId of this.filterModel.StudioIds) {
      const studio = studioCatalog.get(studioId);
      if (studio) {
        studioSlugs.push(Utils.createSlug(studio.Name));
      }
    }
    instructorSlugs.push(
      ...instructorTokensForScheduleUrl(this.filterModel.InstructorIds, [...instructorCatalog.values()])
    );
    // Create an array to hold the query parameters
    const queryParams: string[] = [];

    // Add the instructor query parameter
    if (instructorSlugs.length > 0) {
        queryParams.push(`instructor=${instructorSlugs.join(',')}`);
    }

    // Add the studio query parameter
    if (studioSlugs.length > 0) {
      queryParams.push(`studio=${studioSlugs.join(',')}`);
    }

    // Conditionally add the time_range query parameter
    if (this.filterModel.StartTime !== CLASS_FILTER_DEFAULT_START_TIME || this.filterModel.EndTime !== CLASS_FILTER_DEFAULT_END_TIME) {
        queryParams.push(`time_range=${this.filterModel.StartTime},${this.filterModel.EndTime}`);
    }

    if(this.locationId > 0)
    {
      queryParams.push(`location_id=${this.locationId}`);
    }

    const addressIdsForUrl = addressesForSelectedSchedule(this.filterModel.AddressIds, this.filterModel.PartnerKey);
    if (addressIdsForUrl.length > 0) {
      queryParams.push(`address=${addressIdsForUrl.join(',')}`);
    }

    if (this.filterModel.LocationId > 0) {
      queryParams.push(`location=${this.filterModel.LocationId}`);
    }

    const partnerQuery = formatScheduleSelection(parseScheduleSelection(this.filterModel.PartnerKey));
    if (this.sharedScheduleAllowed && partnerQuery) {
      const encoded = partnerQuery.split(',').map(part => encodeURIComponent(part)).join(',');
      queryParams.push(`partner=${encoded}`);
    }

    if(this.inviteCodeStr != null && this.inviteCodeStr !== "")
    {
      queryParams.push(`invite_code=${this.inviteCodeStr}`);
    }

    // Join the query parameters with '&' and create the final query string
    const queryString: string = "/class-schedule?" + queryParams.join('&');

    return queryString;
  }


  getTwoDigitString(num: number): string {
    // Convert the number to a string
    let numStr = num.toString();

    // If the number is less than 10, prepend '0' to it
    if (num < 10) {
        numStr = '0' + numStr;
    }

    return numStr;
}

  ngOnDestroy() {
    this._unsubscribe.next(null);
    this._unsubscribe.complete();
    
    if (this.studioSubscription) {
      this.studioSubscription.unsubscribe();
    }

    // Clean up scroll throttling timers
    if (this.scrollThrottleTimer) {
      clearTimeout(this.scrollThrottleTimer);
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  }

  toggleAddressFilter(addressId: number): void {
    const index = this.filterModel.AddressIds.indexOf(addressId);
    if (index > -1) {
      // Remove the address ID if it already exists
      this.filterModel.AddressIds.splice(index, 1);
    } else {
      // Add the address ID if it doesn't exist
      this.filterModel.AddressIds.push(addressId);
    }
    this.calculateFilterCount(); // Recalculate the filter count if needed
    window.location.href = this.generateUrl();
  }

  isAddressSelected(addressId: number): boolean {
    return this.filterModel.AddressIds.includes(addressId);
  }

  toggleStudioFilter(studioId: number): void {
    const index = this.filterModel.StudioIds.indexOf(studioId);
    if (index > -1) {
      // Remove the studio ID if it already exists
      this.filterModel.StudioIds.splice(index, 1);
    } else {
      // Add the studio ID if it doesn't exist
      this.filterModel.StudioIds.push(studioId);
    }
    this.calculateFilterCount(); // Recalculate the filter count if needed
    window.location.href = this.generateUrl();
  }

  isStudioSelected(studioId: number): boolean {
    return this.filterModel.StudioIds.includes(studioId);
  }

  toggleInstructorFilter(instructorId: number): void {
    const index = this.filterModel.InstructorIds.indexOf(instructorId);
    if (index > -1) {
      // Remove the instructor ID if it already exists
      this.filterModel.InstructorIds.splice(index, 1);
    } else {
      // Add the instructor ID if it doesn't exist
      this.filterModel.InstructorIds.push(instructorId);
    }
    this.calculateFilterCount(); // Recalculate the filter count if needed
    window.location.href = this.generateUrl();
  }

  isInstructorSelected(instructorId: number): boolean {
    return this.filterModel.InstructorIds.includes(instructorId);
  }

  toggleLocationFilter(locationId: number): void {
    // Toggle location - if same location is clicked, deselect it
    if (this.filterModel.LocationId === locationId) {
      this.filterModel.LocationId = 0;
    } else {
      this.filterModel.LocationId = locationId;
    }
    this.calculateFilterCount(); // Recalculate the filter count if needed
    window.location.href = this.generateUrl();
  }

  isLocationSelected(locationId: number): boolean {
    return this.filterModel.LocationId === locationId;
  }

  hasActualSessions(): boolean {
    if (!this.filteredSessions || this.filteredSessions.length === 0) {
      return false;
    }
    // Check if there are any sessions with Id > 0 (excluding header rows with Id === 0)
    return this.filteredSessions.some(session => session.Id > 0);
  }

  private async refreshWaitlistStatuses(): Promise<void> {
    if (!this.memberId || !this.sessions || this.sessions.length === 0) {
      this.waitlistSessionSet.clear();
      this.cdr.markForCheck();
      return;
    }

    const fullSessionIds = this.sessions
      .filter((session: Session) => session.Id > 0 && session.SpotsLeft === 0)
      .map((session: Session) => session.Id);

    if (fullSessionIds.length === 0) {
      this.waitlistSessionSet.clear();
      this.cdr.markForCheck();
      return;
    }

    const waitlistResponses = await Promise.all(
      fullSessionIds.map((sessionId: number) =>
        this.sessionWaitlistService.get(sessionId).catch(() => [] as SessionWaitlist[])
      )
    );

    const nextWaitlistSet = new Set<number>();
    waitlistResponses.forEach((rows: SessionWaitlist[], index: number) => {
      if (rows.some((row: SessionWaitlist) => Number(row.MemberId) === Number(this.memberId))) {
        nextWaitlistSet.add(Number(fullSessionIds[index]));
      }
    });

    this.waitlistSessionSet = nextWaitlistSet;
    this.cdr.markForCheck();
  }
}